module.exports = __webpack_public_path__ + "img/img_sub_ser_transformation_04.c4433a56.svg";